import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const UTMRedirect = ({ source, medium, campaign }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const utmParams = new URLSearchParams({
      utm_source: source,
      utm_medium: medium,
      utm_campaign: campaign,
    });

    navigate(`/download?${utmParams.toString()}`, { replace: true });
  }, [source, medium, campaign, navigate]);

  return null;
};

export default UTMRedirect;
